import { createSlice, Draft } from '@reduxjs/toolkit'

export interface ITheme {
  theme: 'dark' | 'light'
}

export const initialThemeState: ITheme = {
  theme: 'dark',
}

export const themeSlice = createSlice({
  name: 'themes',
  initialState: initialThemeState,
  reducers: {
    setTheme: (state: Draft<ITheme>, { payload }) => {
      state.theme = payload.theme
    },
  },
})

export const { setTheme } = themeSlice.actions

export default themeSlice.reducer
